import './PriorityIndicator.css';

export const PriorityIndicatorGroup = ({ 
  children,
  className = '' 
}) => {
  return (
    <div className={`priority-indicator-group ${className}`.trim()}>
      {children}
    </div>
  );
};

